import PersonIcon from "@mui/icons-material/Person";
import { Card, CardContent, Stack, Typography } from "@mui/material";

interface Props {
  shipment: SupplierShipment | undefined;
}

export function SupplierInformationSection(props: Props) {
  const { shipment } = props;

  if (!shipment?.supplier) {
    return null;
  }

  const { supplier } = shipment;
  const supplierCompany = shipment.supplier_company;
  const supplierBranch = shipment.supplier.branch;

  return (
    <Card sx={{ flex: 1, minWidth: "300px", boxShadow: 1 }}>
      <CardContent>
        <Stack direction="column" spacing={2}>
          <Stack direction="column" spacing={1}>
            <Typography variant="h6">Supplier</Typography>
            <Typography variant="body1" fontWeight="bold">
              {supplierCompany.name}
              {supplierBranch && (
                <>
                  {" - "}
                  {supplierBranch.name}
                </>
              )}
            </Typography>
          </Stack>

          <Stack direction="column" spacing={1}>
            <Stack direction="row" alignItems="flex-start" spacing={1}>
              <PersonIcon color="primary" fontSize="small" sx={{ mt: 0.5 }} />
              <Stack direction="column">
                <Typography variant="body1">
                  {supplier.user.first_name} {supplier.user.last_name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {supplier.user.email}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
